(function () {
  'use strict';

  document.querySelectorAll('.c_faq_tabs').forEach(function (root) {
    // アコーディオン開閉
    root.querySelectorAll('.c_faq_tabs__title').forEach(function (title) {
      title.addEventListener('click', function () {
        var body = title.nextElementSibling; // .c_faq_tabs__body
        if (body && body.classList.contains('c_faq_tabs__body')) {
          body.classList.toggle('is-active');
        }
        var plus = title.querySelector('.c_faq_tabs__plus');
        if (plus) plus.classList.toggle('is-active');
      });
    });

    // 「続きを読む」ボタン
    root.querySelectorAll('.c_faq_tabs__content').forEach(function (content) {
      var button = content.querySelector('.c_faq_tabs__more-button');
      if (!button) return;

      var label = button.querySelector('.c_faq_tabs__more-label');
      var moreLabel = button.getAttribute('data-more-label') || '';
      var lessLabel = button.getAttribute('data-less-label') || '';

      button.addEventListener('click', function () {
        var expanded = content.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        // 閉じるラベルが未設定なら、開いたあとはボタンを隠す
        if (expanded && lessLabel === '') {
          button.hidden = true;
          return;
        }
        if (label) label.textContent = expanded ? lessLabel : moreLabel;
      });
    });

    // タブ切替に応じた表示（.c_faq_tabs__tablist で囲むと :checked の兄弟
    // セレクタが使えないため JS で制御）
    var radios = root.querySelectorAll('.c_faq_tabs__radio');
    var contents = root.querySelectorAll('.c_faq_tabs__content');

    function sync() {
      radios.forEach(function (radio, i) {
        if (contents[i]) {
          contents[i].style.display = radio.checked ? 'block' : 'none';
        }
      });
    }
    radios.forEach(function (radio) {
      radio.addEventListener('change', sync);
    });
    sync();
  });
})();